import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { mediaSrc } from "@/lib/api";

const DEFAULT_MARK = "/onedot6-mark.png";
const DEFAULT_ASPECT = 1600 / 419;

/** The Onedot 6 wordmark. Uses CMS branding.logo_url when set, else bundled PNG.
 *  When `light` (e.g. over a dark hero), prefers branding.logo_light_url, otherwise
 *  renders the monochrome mark in white via a filter so it stays legible. */
export default function Logo({ height = 26, to, light = false, className, testId = "brand-logo", alt = "Onedot 6" }) {
  const { settings } = useSettings();
  const uploaded = settings?.branding?.logo_url || "";
  const uploadedLight = settings?.branding?.logo_light_url || "";
  const src = light
    ? (uploadedLight ? mediaSrc(uploadedLight) : (uploaded ? mediaSrc(uploaded) : DEFAULT_MARK))
    : (uploaded ? mediaSrc(uploaded) : DEFAULT_MARK);
  // Apply white-out filter only when we're in light mode with no dedicated light asset.
  const whiten = light && !uploadedLight;
  const width = Math.round(height * DEFAULT_ASPECT);
  const img = (
    <img
      src={src}
      alt={alt}
      data-testid={testId}
      style={{ height, width, objectFit: "contain", filter: whiten ? "brightness(0) invert(1)" : undefined }}
      className="block"
    />
  );
  if (to) {
    return (
      <Link to={to} aria-label={alt} data-testid={`${testId}-btn`} className={className}>
        {img}
      </Link>
    );
  }
  return <span className={className}>{img}</span>;
}
